// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"deleteTrade_buttonsContainer__FwplZ"};